import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LineIcon } from './icons';
import { getActiveKey, HOME_PATHS } from '../utils/navActive';
import { useHomeScrollSpy } from '../hooks/useHomeScrollSpy';
import { useLanguage } from '../i18n/LanguageContext';
import { cx } from '../utils/cx';
import mixins from '../styles/mixins.module.css';
import styles from './TabBar.module.css';

const TABS = [
  { k: 'home', to: '/', labelKey: 'navHome', icon: 'home' },
  { k: 'apps', to: '/apps', labelKey: 'navApps', icon: 'grid' },
  { k: 'studio', to: '/studio', labelKey: 'navStudio', icon: 'craft' },
  { k: 'contact', to: '/contact', labelKey: 'navContact', icon: 'mail' },
];

// iOS 26-style floating glass tab bar, shown only below 700px via CSS.
export default function TabBar() {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const spyKey = useHomeScrollSpy(HOME_PATHS.includes(pathname));
  const activeKey = spyKey || getActiveKey(pathname);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      setHidden(y > lastY && y > 300);
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={cx(mixins.glass, styles.tabbar, hidden && styles.hide)} aria-label="Bottom navigation">
      {TABS.map((tab) => (
        <Link key={tab.k} to={tab.to} className={cx(styles.tab, activeKey === tab.k && styles.active)}>
          <LineIcon name={tab.icon} strokeWidth={tab.k === 'contact' ? 2 : 2.2} />
          {t(tab.labelKey)}
        </Link>
      ))}
    </nav>
  );
}
